// src/components/AddressSelectBar/AddressSelectBar.jsx
import React, { useState } from "react";
import "./AddressSelectBar.css";
import { TbHome, TbChevronDown } from "react-icons/tb";
import { useLanguage } from "../../LanguageProvider";

export default function AddressSelectBar({
  addresses = [],
  selectedAddressId,
  onSelect,
  onClear,
  placeholder 
}) {
  const [isOpen, setIsOpen] = useState(false);

  const selected = addresses.find((a) => a.id === selectedAddressId);
  const label = selected ? selected.label : placeholder;
  const isActive = !!selected;

  const { getTranslation } = useLanguage();

  const handleOptionClick = (addr) => {
    if (onSelect) onSelect(addr);
    setIsOpen(false);
  };

  const handleClear = () => {
    if (onClear) onClear();
    setIsOpen(false);
  };

  return (
    <div className="address-select-wrapper">
      <button
        type="button"
        className={`address-select-bar ${isActive ? "address-select-bar-active" : ""
          }`}
        onClick={() => {
          if (!addresses.length) {
            // TODO: Kayıtlı adres yoksa burada adres fetch servisi tetiklenebilir.
            return;
          }
          setIsOpen((prev) => !prev);
        }}
      >
        <TbHome size={16} className="address-select-bar-icon" />
        <span className="address-select-bar-label">{label}</span>
        <TbChevronDown
          size={16}
          className={`address-select-bar-chevron ${isOpen ? "address-select-bar-chevron-open" : ""
            }`}
        />
      </button>

      {isOpen && addresses.length > 0 && (
        <div className="address-select-dropdown">
          {addresses.map((addr) => (
            <button
              key={addr.id}
              type="button"
              className={`address-select-option ${addr.id === selectedAddressId
                  ? "address-select-option-active"
                  : ""
                }`}
              onClick={() => handleOptionClick(addr)}
            >
              <TbHome size={14} className="address-select-option-icon" />
              <span className="address-select-option-label">
                {addr.label}
              </span>
            </button>
          ))}

          {selectedAddressId && (
            <>
              <div className="address-select-divider" />
              <button
                type="button"
                className="address-select-option address-select-option-clear"
                onClick={handleClear}
              >
                {getTranslation("addressSelectClear")}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}